var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJoint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 32,
    viewBox: "0 0 39 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6555_43702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4021 16.411C18.6341 15.2388 17.664 14.2687 16.5322 13.5007C16.3706 13.3794 16.1684 13.4199 16.0068 13.5411C14.5516 14.5921 12.7731 15.2388 10.8328 15.2388C8.89263 15.2388 7.11411 14.6324 5.65894 13.5411C5.49727 13.4199 5.29516 13.4199 5.13348 13.5007C1.69769 15.7239 0 20.0489 0 25.0207C0 27.1226 8.20548 27.931 14.5516 27.446C14.8346 22.7571 16.5322 18.8767 19.4021 16.411Z",
    fill: "#700700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8328 12.9348C14.4046 12.9348 17.3002 10.0392 17.3002 6.46737C17.3002 2.89554 14.4046 0 10.8328 0C7.26102 0 4.36548 2.89554 4.36548 6.46737C4.36548 10.0392 7.26102 12.9348 10.8328 12.9348Z",
    fill: "#700700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2664 17.381C33.1048 17.2598 32.9027 17.3003 32.741 17.4215C31.2859 18.4725 29.5073 19.1191 27.5671 19.1191C25.6269 19.1191 23.8483 18.4725 22.3932 17.4215C22.2316 17.3003 22.0294 17.3003 21.8678 17.381C18.4723 19.5638 16.7747 23.8888 16.7747 28.8607C16.7747 32.2965 38.4 32.2965 38.4 28.8607C38.4 23.8888 36.7022 19.5638 33.2664 17.381Z",
    fill: "#700700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5672 16.8152C31.1391 16.8152 34.0346 13.9196 34.0346 10.3478C34.0346 6.77591 31.1391 3.88037 27.5672 3.88037C23.9954 3.88037 21.0999 6.77591 21.0999 10.3478C21.0999 13.9196 23.9954 16.8152 27.5672 16.8152Z",
    fill: "#700700"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6555_43702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.4,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoint);
export default __webpack_public_path__ + "static/media/joint.964edb7a612c3386f6b918860a3d77d5.svg";
export { ForwardRef as ReactComponent };